<template>
  <v-card v-if="dialogHelp" elevation="8">
    <!-- Cabeçalho -->
    <v-toolbar color="primary" dark dense>
      <v-toolbar-title class="font-weight-bold">
        <v-icon left>mdi-help-circle</v-icon>
        Informações sobre o sistema
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="alterarDialogHelp">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Conteúdo -->
    <v-card-text class="help-content">
      <v-container fluid>
        <v-row v-for="(itemHelp, i) in listaHelp" :key="i" class="mb-4">
          <v-col cols="12">
            <h3 class="teal--text text--darken-2 text-center font-weight-bold mb-3">
              {{ itemHelp[0].titulo }}
            </h3>
            <v-divider class="mb-4" />
            
            <v-expansion-panels accordion flat>
              <v-expansion-panel
                v-for="(item, j) in itemHelp"
                :key="j"
                class="mb-2"
              >
                <v-expansion-panel-header class="font-weight-medium">
                  {{ item.subtitulo }}
                  <template v-slot:actions>
                    <v-icon color="teal">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-card-text class="pt-2">
                      {{ item.texto }}
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Rodapé -->
    <v-card-actions class="px-4 pb-3">
      <v-spacer />
      <v-btn
        color="teal"
        text
        @click="alterarDialogHelp"
      >
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    listaHelp: {
      type: Array,
      default: () => ([])
    },
    dialogHelp: Boolean,
    descricaoDialogo: String
  },
  methods: {
    alterarDialogHelp() {
      this.$emit('alterar-dialog-help')
    }
  }
}
</script>

<style scoped>


</style>